import React from "react"

const Notification = ({ text, top, left, global }) => {
    const style = global ? {} : { top: `${top}px`, left: `${left}px` }

    return (
        <div className={`buy-button__tooltip${global ? " buy-button__tooltip--global" : ""}`} style={style}>
            <div className="buy-button__tooltip-inner">{text}</div>
        </div>
    )
}

export default Notification
